import * as formik from "formik";
import * as yup from "yup";
import 'yup-phone-lite';
import { isValidBIC, bankDataByIBAN } from "bankdata-germany"
import { isValidIBAN } from "ibantools-germany"
import React, {Component, useEffect, useState, forwardRef} from "react";
import APIController from "../../controller/APIController";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBank, faEnvelope, faEnvelopeOpen, faHandshake, faHashtag,
    faHourglassStart, faLocationDot, faPerson,
    faPhone,
    faPhoneAlt, faPhoneSquareAlt, faRoad, faTreeCity,
    faUser, faUserAlt,
    faUserTie,
    faVault
} from "@fortawesome/free-solid-svg-icons";
import LoadingScreen from "../../includes/LoadingScreen";
import PageHeader from "../../includes/PageHeader";
import PageContent from "../../includes/PageContent";
import CenteredMessage from "../../includes/CenteredMessage";
import ObjectUtil from "../../util/objectUtil";
import config from "../../config";
import EinverstaendniserklaerungCheckbox from "../../components/EinverstaendniserklaerungCheckbox";
import UserController from "../../controller/UserController";

yup.addMethod(yup.string, 'validateIban', function(message) {
    return this.test('test-iban-number', message, function(value) {
        if (!value) {
            return true;
        }
        return isValidIBAN(value, true);
    });
});

yup.addMethod(yup.string, 'validateBIC', function(message) {
    return this.test('test-bic-from-iban', message, function (value) {
        if (!value){
            return true;
        }
        return isValidBIC(value);
    });
});


const ProfileUpdateForm = (props) => {

    // Fetch Profile Values

    const { Formik, getIn } = formik;
    const schema = yup.object().shape({
        communicationData: yup.object().shape({
            communicationEntryType: yup.string().oneOf(["P", "G"], "Bitte wähle 'Privat' oder 'Geschäftlich' für Kommunikationstyp").required("Kommunikationstyp ist ein Pflichtfeld"),
            phone: yup.string().phone("DE", "Bitte gebe eine gültige Telefon ein").required("Telefon ist ein Pflichtfeld"),
            email: yup.string().email('Bitte gebe eine gültige E-Mail-Adresse ein').required("E-Mail ist ein Pflichtfeld"),
            mobile: yup.string().phone("DE", "Bitte gebe eine gültige Mobiltelefon ein").required("Mobiltelefon ist ein Pflichtfeld"),
        }),
        bankDetails: yup.object().shape({
            iban: yup.string()
                .validateIban("Diese IBAN ist nicht gültig, bitte geben Sie eine gültige IBAN einer gültigen deutschen Bank an")
                .required("IBAN ist ein Pflichtfeld"),
            bic: yup.string()
                .validateBIC("Dieser BIC ist ungültig, bitte gültigen BIC angeben")
                .required("BIC ist ein Pflichtfeld"),
            creditInstitution: yup.string().required("Kreditinstitut ist ein Pflichtfeld")
                .test(
                "is-not-blank",
                "Kreditinstitut darf nicht leer sein",
                value => !!value && value.trim().length > 0
                )
                .matches(
                    /^[\w\säöüÄÖÜß().,&/-]+$/,
                    "Kreditinstitut enthält ungültige Zeichen"
                ),
            differentAccountHolder: yup.string(),
            lfdnr: yup.number(),
        }),
        legalGuardian: yup.object().shape({
            salutation: yup.string().required("Anrede ist ein Pflichtfeld"),
            name: yup.string().required("Name des Erziehungsberechtigten ist ein Pflichtfeld"),
            firstname: yup.string().required("Vorname des Erziehungsberechtigten ist ein Pflichtfeld"),
            street: yup.string().required("Strasse ist ein Pflichtfeld"),
            zip: yup.string().matches('^(?!01000|99999)(0[1-9]\\d{3}|[1-9]\\d{4})$', 'Bitte gebe eine gültige Postleitzahl ein').required("Postleitzahl ist ein Pflichtfeld"),
            city: yup.string().required("Stadt ist ein Pflichtfeld"),
            phone: yup.string().phone("DE", "Bitte gebe eine gültige Telefon ein").required("Telefon ist ein Pflichtfeld"),
            email: yup.string().email('Bitte gebe eine gültige E-Mail-Adresse ein')
        }),
    });

    const initialValuesFromProfileProps = ObjectUtil.convertNullToEmpty(props.profile);
    initialValuesFromProfileProps.communicationData.communicationEntryType = "P";
    const [initialValues, setInitialValues] = React.useState(initialValuesFromProfileProps);
    const [apiResponseMessage, setApiResponseMessage] = useState("")
    const [inProgress, setInProgress] = useState(false);
    const [alertType, setAlertType] = useState("alert-danger");

    useEffect(() => {
        const errorMessageCleaner = setInterval(() => {
            if(apiResponseMessage !== ""){
                setApiResponseMessage("");
                setAlertType("alert-danger");
            }
        }, config.API_MESSSAGE_SHOW_TIMER);
        return () => clearInterval(errorMessageCleaner);
    }, [apiResponseMessage, alertType]);


    const onSubmitForm = async (values, { resetForm }) => {
        try {
            setApiResponseMessage("");
            setInProgress(true);
            props.state_update_handler({
                profile: values,
                isFetching: true,
            })
            let updatedProfileResponse = await APIController.updateTraineeProfile(values);
            if(updatedProfileResponse){
                setAlertType("alert-success");
                setApiResponseMessage("Dein Profil wurde erfolgreich aktualisiert")
                resetForm();
                props.state_update_handler({
                    isFetching: false
                })
                setInProgress(false);
            }
        }
        catch (error){
            console.error(error);
            //resetForm();
            setInProgress(false);
            alert(error.message);
        }
        finally {
            window.location.reload();
        }
    }
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmitForm}
            onValidationError={errorValues => {
                window.alert("failed")
            }}
            validationSchema={schema}
        >

            {({ handleSubmit, setFieldValue, values, handleBlur, isValid,handleChange, touched, errors, validateForm}) => (
                <Form  onSubmit={handleSubmit}
                       autoComplete="off">
                    <div className="communicationData">
                        <Row>
                            <Col className="mb-4">
                                <h4 className="fw-bold">
                                    Kommunikationsdaten
                                </h4>
                            </Col>
                        </Row>
                        <Row>
                            {/* // HIDE (SELECTION BOX FOR TYPE OF COMMUNICATION ENTRIES) TEMPORARILY TO NOT BLOAT UX
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faEnvelopeOpen}/> Kommunikationstyp*
                                    </Form.Label>
                                    <Form.Select
                                        name={'communicationData.communicationEntryType'}
                                        id={'communicationData.communicationEntryType'}
                                        defaultValue={values.communicationData.communicationEntryType}
                                        onBlur={handleBlur}
                                        isInvalid={
                                            (!!touched.communicationData && !!touched.communicationData.communicationEntryType) &&
                                            (!!errors.communicationData && !!errors.communicationData.communicationEntryType)
                                        }
                                        onChange={(e) => {
                                            return setFieldValue("communicationData.communicationEntryType", e.target.value)
                                        }}>
                                        { initialValues.communicationData.communicationEntryTypeOptions.map((option) => {
                                            return (<option key={option.key} value={option.key}>
                                                {option.value}
                                            </option>)
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.communicationData && !!errors.communicationData.communicationEntryType) ? errors.communicationData.communicationEntryType : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            */}
                            <Col xs={12} md={12} lg={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faEnvelopeOpen}/> E-Mail*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'communicationData.email'}
                                                  id={'communicationData.email'}
                                                  placeholder="E-Mail eingeben"
                                                  value={values.communicationData.email}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.communicationData && !!touched.communicationData.email) &&
                                                      (!!errors.communicationData && !!errors.communicationData.email)
                                                  }
                                                  onChange={(e) => setFieldValue("communicationData.email", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {(!!errors.communicationData && !!errors.communicationData.email) ? errors.communicationData.email : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faPhone}/> Telefon*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'communicationData.phone'}
                                                  id={'communicationData.phone'}
                                                  placeholder="Telefon eingeben"
                                                  value={values.communicationData.phone}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.communicationData && !!touched.communicationData.phone) &&
                                                      (!!errors.communicationData && !!errors.communicationData.phone)
                                                  }
                                                  onChange={(e) => setFieldValue("communicationData.phone", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {(!!errors.communicationData && !!errors.communicationData.phone) ? errors.communicationData.phone : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faPhoneAlt}/> Mobiltelefon*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'communicationData.mobile'}
                                                  id={'communicationData.mobile'}
                                                  placeholder="Mobiltelefon eingeben"
                                                  value={values.communicationData.mobile}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.communicationData && !!touched.communicationData.mobile) &&
                                                      (!!errors.communicationData && !!errors.communicationData.mobile)
                                                  }
                                                  onChange={(e) => setFieldValue("communicationData.mobile", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {(!!errors.communicationData && !!errors.communicationData.mobile) ? errors.communicationData.mobile : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col className="mt-5">
                            <h4 className="fw-bold">Einverständniserklärung</h4>
                            <EinverstaendniserklaerungCheckbox traineeProfile={props.profile} />
                        </Col>
                    </Row>
                    <div className="bankDetails mt-5">
                        <Row>
                            <Col className="mb-4">
                                <h4 className="fw-bold">
                                    Bankdaten
                                </h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faVault}/> IBAN*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'bankDetails.iban'}
                                                  id={'bankDetails.iban'}
                                                  placeholder="IBAN eingeben"
                                                  value={values.bankDetails.iban}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.bankDetails && !!touched.bankDetails.iban) &&
                                                      (!!errors.bankDetails && !!errors.bankDetails.iban)
                                                  }
                                                  onChange={(e) => {
                                                      const newIban = e.target.value;
                                                      setFieldValue("bankDetails.iban", newIban);

                                                      const bankData = newIban.length >= 15 ? bankDataByIBAN(newIban) : null;
                                                      if(bankData){
                                                          // Populate only if no initial value present for bic & creditInstitution
                                                          if(!values.bankDetails.bic){
                                                              setFieldValue("bankDetails.bic", bankData.bic || "")
                                                          }
                                                          if (!values.bankDetails.creditInstitution) {
                                                              setFieldValue("bankDetails.creditInstitution", bankData.bankName || "")
                                                          }

                                                      }
                                                  }}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.bankDetails && !!errors.bankDetails.iban) ? errors.bankDetails.iban : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faVault}/> BIC*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'bankDetails.bic'}
                                                  id={'bankDetails.bic'}
                                                  placeholder="BIC eingeben"
                                                  value={values.bankDetails.bic}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.bankDetails && !!touched.bankDetails.bic) &&
                                                      (!!errors.bankDetails && !!errors.bankDetails.bic)
                                                  }
                                                  onChange={(e) => setFieldValue("bankDetails.bic", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.bankDetails && !!errors.bankDetails.bic) ? errors.bankDetails.bic : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            {/*<Col xs={12} md={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faHashtag}/> LFDnr
                                    </Form.Label>
                                    <Form.Control type="number"
                                                  name={'bankDetails.lfdnr'}
                                                  id={'bankDetails.lfdnr'}
                                                  placeholder="LFDnr eingeben"
                                                  value={values.bankDetails.lfdnr}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.bankDetails && !!touched.bankDetails.lfdnr) &&
                                                      (!!errors.bankDetails && !!errors.bankDetails.lfdnr)
                                                  }
                                                  onChange={(e) => setFieldValue("bankDetails.lfdnr", e.target.value)}
                                                  disabled
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.bankDetails && !!errors.bankDetails.lfdnr) ? errors.bankDetails.lfdnr : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>*/}
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faBank}/> Kreditinstitut*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'bankDetails.creditInstitution'}
                                                  id={'bankDetails.creditInstitution'}
                                                  placeholder="Kreditinstitut eingeben"
                                                  value={values.bankDetails.creditInstitution}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.bankDetails && !!touched.bankDetails.creditInstitution) &&
                                                      (!!errors.bankDetails && !!errors.bankDetails.creditInstitution)
                                                  }
                                                  onChange={(e) => setFieldValue("bankDetails.creditInstitution", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.bankDetails && !!errors.bankDetails.creditInstitution) ? errors.bankDetails.creditInstitution : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faUserTie}/> Abweichender Kontoinhaber
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'bankDetails.differentAccountHolder'}
                                                  id={'bankDetails.differentAccountHolder'}
                                                  placeholder="Abweichender Kontoinhaber eingeben"
                                                  value={values.bankDetails.differentAccountHolder}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.bankDetails && !!touched.bankDetails.differentAccountHolder) &&
                                                      (!!errors.bankDetails && !!errors.bankDetails.differentAccountHolder)
                                                  }
                                                  onChange={(e) => setFieldValue("bankDetails.differentAccountHolder", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.bankDetails && !!errors.bankDetails.differentAccountHolder) ? errors.bankDetails.differentAccountHolder : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>

                    <div className={'legalGuardian mt-5'}>
                        <Row>
                            <Col className="mb-4">
                                <h4 className="fw-bold">
                                    Informationen zum Erziehungsberechtigten
                                </h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={3} lg={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faHandshake}/> Anrede*
                                    </Form.Label>
                                    <Form.Select
                                        name={'legalGuardian.salutation'}
                                        id={'legalGuardian.salutation'}
                                        defaultValue={values.legalGuardian.salutation}
                                        onBlur={handleBlur}
                                        isInvalid={
                                            (!!touched.legalGuardian && !!touched.legalGuardian.salutation) &&
                                            (!!errors.legalGuardian && !!errors.legalGuardian.salutation)
                                        }
                                        onChange={(e) => {
                                            return setFieldValue("legalGuardian.salutation", e.target.value)
                                        }}>
                                        {initialValues.legalGuardian.allSalutationOptions.map((option) => {
                                            return (<option key={option.key} value={option.key}>
                                                {option.value}
                                            </option>)
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.salutation) ? errors.legalGuardian.salutation : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faUserAlt}/> Vorname*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.firstname'}
                                                  id={'legalGuardian.firstname'}
                                                  placeholder="Vorname eingeben"
                                                  value={values.legalGuardian.firstname}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.firstname) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.firstname)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.firstname", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.firstname) ? errors.legalGuardian.firstname : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={5} lg={5}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faPerson}/> Nachname*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.name'}
                                                  id={'legalGuardian.name'}
                                                  placeholder="Nachname eingeben"
                                                  value={values.legalGuardian.name}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.name) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.name)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.name", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.name) ? errors.legalGuardian.name : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faPhoneSquareAlt}/> Telefon*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.phone'}
                                                  id={'legalGuardian.phone'}
                                                  placeholder="Telefon eingeben"
                                                  value={values.legalGuardian.phone}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.phone) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.phone)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.phone", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.phone) ? errors.legalGuardian.phone : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faEnvelope}/> E-Mail
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.email'}
                                                  id={'legalGuardian.email'}
                                                  placeholder="E-Mail eingeben"
                                                  value={values.legalGuardian.email}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.email) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.email)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.email", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.email) ? errors.legalGuardian.email : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} md={12} lg={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faRoad}/> Strasse*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.street'}
                                                  id={'legalGuardian.street'}
                                                  placeholder="Strasse eingeben"
                                                  value={values.legalGuardian.street}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.street) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.street)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.street", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.street) ? errors.legalGuardian.street : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faLocationDot}/> PLZ*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.zip'}
                                                  id={'legalGuardian.zip'}
                                                  placeholder="PLZ eingeben"
                                                  value={values.legalGuardian.zip}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.zip) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.zip)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.zip", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.zip) ? errors.legalGuardian.zip : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={8} lg={8}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-center">
                                        <FontAwesomeIcon icon={faTreeCity}/> Ort*
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  name={'legalGuardian.city'}
                                                  id={'legalGuardian.city'}
                                                  placeholder="Ort eingeben"
                                                  value={values.legalGuardian.city}
                                                  onBlur={handleBlur}
                                                  isInvalid={
                                                      (!!touched.legalGuardian && !!touched.legalGuardian.city) &&
                                                      (!!errors.legalGuardian && !!errors.legalGuardian.city)
                                                  }
                                                  onChange={(e) => setFieldValue("legalGuardian.city", e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid" >
                                        {(!!errors.legalGuardian && !!errors.legalGuardian.city) ? errors.legalGuardian.city : ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>

                    <div className="mt-1 fw-semibold">Felder, die mit * markiert sind, sind Pflichtfelder</div>

                    {apiResponseMessage &&
                        <div className={"mt-3 mb-3 alert " + alertType } dangerouslySetInnerHTML={{__html: apiResponseMessage}}/>
                    }
                    {
                    <div className="d-grid mt-5">
                        <div align={'center'}>
                            <div style={{display: 'inline-block', marginRight: '0.5em'}}>
                                {!inProgress ?
                                    <Button
                                        type="submit"
                                        disabled={!isValid}
                                        variant="primary">
                                        Profildaten speichern
                                    </Button> :
                                    <span>Bitte warten <FontAwesomeIcon icon={faHourglassStart}/></span>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </Form>
            )}
        </Formik>
    )
}

class TraineeProfileUpdateForm extends Component {
    constructor(props){
        super(props);
        this.params = props.params;
        this.state = {
            isFetching: true,
            reload: true,
            profile : null,
        };

    }

    state_update_handler = (newStateValue) => {
        this.setState(newStateValue);
    }

    async componentDidMount() {
        await this.reload();

    }

    async reload(){
        try {
            this.setState({
                isFetching:true
            })
            const profileResponse = await APIController.getTraineeProfile(UserController.getUser().id);

            this.setState({
                isFetching: false,
                reload:false,
                profile : profileResponse,
            });
        } catch (error) {
            this.setState({
                isFetching: false,
                profile: null
            });
        }
    }

    render() {
        if(!this.state.isFetching && this.state.profile == null){
            return (
                <>
                    <PageHeader title={"Aktualisiere bitte das Azubi-Profil"} fontAwesomeIcon={faUser}/>
                    <PageContent>
                        <CenteredMessage>
                            <FontAwesomeIcon icon={faUser} />
                            Das Profilaktualisierungsformular konnte nicht geladen werden
                        </CenteredMessage>
                    </PageContent>
                </>
            )
        }
        return (
            <>
                {this.state.isFetching ? (<LoadingScreen />):
                    <div className="TraineeProfileUpdateForm">
                        <PageContent>
                            <Container style={{maxWidth: 'calc(80vw)'}}>
                                <ProfileUpdateForm profile={this.state.profile} state_update_handler={this.state_update_handler} />
                            </Container >
                        </PageContent>
                    </div>
                }
            </>
        )

    }
}

export default TraineeProfileUpdateForm;
